import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn } from '../shared/interface/generic-interface';

@Injectable()
export class BoxInfoJourneyService {

  constructor(private conService: ApiConService) { }

  async getInfoJourney() {
    try {
      const response: JsonReturn = await this.conService.patch('roteiroVeiculo');
      return response.response;
    }catch (Error) {
      console.log("CATCH________getInfoJourney");
      console.log(Error);
    }
  }
}
